import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export interface MevCredentialsDTO extends z.infer<typeof MevCredentialsDTORuntype> {}
export const MevCredentialsDTORuntype = z.object({
    client_id: z.string(),
    api_key: z.string(),
});

export interface MevCredentialsInputDTO extends z.infer<typeof MevCredentialsInputDTORuntype> {}
export const MevCredentialsInputDTORuntype = z.object({
    client_id: z.string().optional(),
    api_key: z.string().optional(),
});

export interface MevResponseBodyDTO extends z.infer<typeof MevResponseBodyDTORuntype> {}
export const MevResponseBodyDTORuntype = z.object({
    data: MevCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
